module.exports = __webpack_public_path__ + "f5ff149ea165cef0618cdd7c1075e5ca.jpg";